export const INDIAN_STATES = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Other Territory",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

const STATE_ALIASES: Record<string, string> = {
  tamilnadu: "Tamil Nadu",
  orissa: "Odisha",
  pondicherry: "Puducherry",
  uttaranchal: "Uttarakhand",
  chattisgarh: "Chhattisgarh",
  "jammu & kashmir": "Jammu and Kashmir",
  "andaman & nicobar islands": "Andaman and Nicobar Islands",
  "dadra & nagar haveli": "Dadra and Nagar Haveli and Daman and Diu",
  "daman & diu": "Daman and Diu",
  "new delhi": "Delhi",
  "nct of delhi": "Delhi",
  "delhi (nct)": "Delhi",
};

const STATE_LOOKUP: Record<string, string> = {
  ...INDIAN_STATES.reduce(
    (acc, name) => ({ ...acc, [name.toLowerCase()]: name }),
    {} as Record<string, string>
  ),
  ...STATE_ALIASES,
};

/**
 * The canonical spelling of an Indian state/UT name, or "" if `value` names none.
 * Mirrors the backend's canonical_state() in gst_portal_client.py — anything this
 * returns "" for is rejected by the address API.
 */
export const canonicalState = (value?: string | null): string => {
  const cleaned = String(value ?? "")
    .replace(/[\s\-–—]*\d{6}\s*$/, "")
    .replace(/^[\s.-]+|[\s.-]+$/g, "")
    .replace(/\s+/g, " ")
    .toLowerCase();
  return STATE_LOOKUP[cleaned] ?? "";
};
